import { render, staticRenderFns } from "./SupplireDocumentForm.vue?vue&type=template&id=c6f3506e&scoped=true&"
import script from "./SupplireDocumentForm.vue?vue&type=script&lang=js&"
export * from "./SupplireDocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplireDocumentForm.vue?vue&type=style&index=0&id=c6f3506e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f3506e",
  null
  
)

export default component.exports